import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

//import { HttpClient } from '@angular/common/http';
import { HttpModule } from '@angular/http';
//import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';

import {shuttleService} from './data/shuttle.service';

import { ShuttleComponent } from './shuttle/shuttle.component';

import { LoggingService } from './logging.service';


import { Shuttle_Start_Component } from './shuttle.start/shuttle.start.component';
import { ShuttleEnRouteComponent } from './shuttle-en-route/shuttle-en-route.component';
import { ShuttleAtStopComponent } from './shuttle-at-stop/shuttle-at-stop.component';
import { ShuttleDeviateRouteComponent } from './shuttle-deviate-route/shuttle-deviate-route.component';
import { ShuttleDeactivateComponent } from './shuttle-deactivate/shuttle-deactivate.component';
import { ShuttleDelayComponent } from './shuttle-delay/shuttle-delay.component';
import { ShuttleDeviateEnRouteComponent } from './shuttle-deviate-en-route/shuttle-deviate-en-route.component';
import { ShuttleLoginComponent } from './shuttle-login/shuttle-login.component';
import { ShuttleBreakComponent } from './shuttle-break/shuttle-break.component';
import { ShuttleDeviateStopComponent } from './shuttle-deviate-stop/shuttle-deviate-stop.component';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ShuttleComponent,
    Shuttle_Start_Component,
    ShuttleEnRouteComponent,
    ShuttleAtStopComponent,
    ShuttleDeviateRouteComponent,
    ShuttleDeactivateComponent,
    ShuttleDelayComponent,
    ShuttleDeviateEnRouteComponent,
    ShuttleLoginComponent,
    ShuttleBreakComponent,
    ShuttleDeviateStopComponent,

  ],
  imports: [
    BrowserModule,AppRoutingModule,HttpModule
  ],
  providers: [shuttleService,LoggingService],
  bootstrap: [AppComponent]
})
export class AppModule { }
